import { render, staticRenderFns } from "./LoadFunds.vue?vue&type=template&id=be95a2ac&scoped=true&"
import script from "./LoadFunds.vue?vue&type=script&lang=js&"
export * from "./LoadFunds.vue?vue&type=script&lang=js&"
import style0 from "./LoadFunds.vue?vue&type=style&index=0&id=be95a2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be95a2ac",
  null
  
)

export default component.exports